import { ChevronLeft, ChevronRight } from "lucide-react";
import { useEffect, useState } from "react";

type BirdPhotoProps = {
  images: string[];
  alt: string;
  className?: string;
  eager?: boolean;
};

export const BirdPhoto = ({
  images,
  alt,
  className = "",
  eager = false
}: BirdPhotoProps) => {
  const [activeImage, setActiveImage] = useState(0);

  useEffect(() => setActiveImage(0), [images]);

  const previous = () =>
    setActiveImage((current) => (current - 1 + images.length) % images.length);
  const next = () =>
    setActiveImage((current) => (current + 1) % images.length);

  return (
    <div className={`bird-photo ${className}`}>
      <img
        src={images[activeImage]}
        alt={alt}
        loading={eager ? "eager" : "lazy"}
        fetchPriority={eager ? "high" : "auto"}
      />
      {images.length > 1 && (
        <>
          <button
            className="bird-photo__arrow bird-photo__arrow--left"
            type="button"
            onClick={previous}
            aria-label="上一张照片"
          >
            <ChevronLeft size={20} />
          </button>
          <button
            className="bird-photo__arrow bird-photo__arrow--right"
            type="button"
            onClick={next}
            aria-label="下一张照片"
          >
            <ChevronRight size={20} />
          </button>
          <div className="bird-photo__dots" aria-label={`第 ${activeImage + 1} 张，共 ${images.length} 张`}>
            {images.map((image, index) => (
              <button
                key={image}
                type="button"
                className={index === activeImage ? "is-active" : ""}
                onClick={() => setActiveImage(index)}
                aria-label={`查看第 ${index + 1} 张照片`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};
